import { IfStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControlName, FormControl, Validators, AbstractControl } from '@angular/forms';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { TranslateTextPipe } from 'src/app/shared/pipes/translateText.pipe';
import { containDigitValidator } from 'src/app/template/customValidators/containDigitValidator';
import { containLowerCaseValidator } from 'src/app/template/customValidators/containLowerCaseValidator';
import { containUpperCaseValidator } from 'src/app/template/customValidators/containUpperCaseValidator';
import { nonAlphaNumericCharactersValidator } from 'src/app/template/customValidators/nonAlphaNumericCharactersValidator';
import { uniqueCharactersValidator } from 'src/app/template/customValidators/uniqueCharactersValidator';
import { AdminService } from 'src/app/workflow/admin/admin.service';

@Component({
  selector: 'app-gip-user-change-pwd-form',
  templateUrl: './gipUserChangePwdForm.component.html',
  styleUrls: ['./gipUserChangePwdForm.component.css']
})
export class GipUserChangePwdFormComponent implements OnInit {

  constructor(
    private shareData: SharingDataService,
    private translateText: TranslateTextPipe,
    private adminService: AdminService,
  ) { }

  gipDefault
  User;
  nonAlphaNumberic;
  minLength;
  lowerCase : boolean;
  upperCase : boolean;
  digit : boolean;
  uniqueChars : number;
  
  passwordValidators;

  formular = [
    { formControlName: "PasswordModelOld", required: true, password: true, newRow: true, type: "password" },
    { formControlName: "PasswordModelNew", required: true, password: true, newRow: true, type: "password" },
    { formControlName: "PasswordModelConfirm", required: true, confirmPassword: true, newRow: true, function: "comparePassword", type: "password" },
  ]

  modelInput : FormGroup;

  resourceDefinition;

  ngOnInit(): void {
    this.modelInput = new FormGroup({
      PasswordModelOld: new FormControl('', Validators.required),
      PasswordModelNew: new FormControl(),
      PasswordModelConfirm: new FormControl('', [Validators.required]),
    });
    
    this.shareData.currentUser.subscribe(data => this.User = data);
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentGipDefault.subscribe((data) => this.gipDefault = data);
    this.nonAlphaNumberic = this.translateText.transform("NONALPHACHARNUM", this.gipDefault, "GIP_NAME", "GIP_VALUE");
    this.minLength = +this.translateText.transform("MINPWDLENGTH", this.gipDefault, "GIP_NAME", "GIP_VALUE");

    this.passwordValidators= [Validators.required,Validators.minLength(this.minLength), Validators.maxLength(128), nonAlphaNumericCharactersValidator(this.nonAlphaNumberic)];

    this.translateText.transform("PWDREQUIRELOWERCASE", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? this.passwordValidators.push(containLowerCaseValidator) : null;
    this.translateText.transform("PWDREQUIREUPPERCASE", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? this.passwordValidators.push(containUpperCaseValidator) : null;
    this.translateText.transform("PWDREQUIREDIGIT", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? this.passwordValidators.push(containDigitValidator) : null;
    this.uniqueChars = +this.translateText.transform("MINPWDLENGTH", this.gipDefault, "GIP_NAME", "GIP_VALUE");    

    if(this.uniqueChars > 0){
      this.passwordValidators.push(uniqueCharactersValidator(this.uniqueChars))
    }

    this.modelInput.controls.PasswordModelNew.setValidators(this.passwordValidators)
  }

  action(action) {
    this[action]();
  }

  enableChangePasswordButton(){
    if(this.comparePassword() && this.modelInput.status == "VALID"){
      return true;
    }
    return false;
  }

  comparePassword(){
    if(this.modelInput.controls.PasswordModelConfirm.errors && this.modelInput.controls.PasswordModelConfirm.errors.required){}
    else if(this.modelInput.value.PasswordModelNew == this.modelInput.value.PasswordModelConfirm && this.modelInput.value.PasswordModelNew != "" && this.modelInput.value.PasswordModelConfirm != ""){
      this.modelInput.controls.PasswordModelConfirm.setErrors(null);
      return true;
    } else {
      this.modelInput.controls.PasswordModelConfirm.setErrors({comparePassword: true});
      return false;
    }
  }

  changePassword(){
    if (this.modelInput.status == "VALID") {
      let model = {
        id: this.User.USERGUID,
        login:  this.User.LOGIN,
        oldpassword: this.modelInput.value.PasswordModelOld,
        newpassword: this.modelInput.value.PasswordModelNew,
      }

      this.adminService.postData("portal/changepassword", model, (data) => {
      });
    }
  }
}